import React, { useState, useEffect } from 'react';
import { client, urlFor } from '../sanityClient';
import SEO from '../components/SEO';
import './VenueDetail.css';

function Parking() {
  const [space, setSpace] = useState(null);

  useEffect(() => {
    client
      .fetch('*[_type == "venue"][0]{ spaces[slug == "parking"][0] }')
      .then(data => {
        if (data && data.spaces) setSpace(data.spaces);
      });
  }, []);

  const images = (space && space.images) || [];
  const validImages = images.filter(img => img && img.asset);

  return (
    <div className="venue-detail-page">
      <SEO
        title="주차 안내 | Parking"
        description="가든포에트 홍대 주차 안내. 상수역 4분 거리, 인근 주차장 정보와 대중교통 안내."
        path="/venue/parking"
      />
      <section className="detail-hero">
        <div className="container">
          <div className="detail-hero-content fade-in">
            <h1>PARKING</h1>
            <p className="capacity-tag">편리한 접근</p>
          </div>
        </div>
      </section>

      <section className="detail-description">
        <div className="container">
          <div className="space-notice fade-in">
            <span className="notice-tag">📷 시즌 프리뷰</span>
          </div>
          <div className="description-content fade-in">
            <p>
              공간 안에 6대.<br />
              바로 옆 극동방송 지하 주차장에 20대.<br />
              2시간은 무료로 지원해드립니다.
            </p>
            <p>
              6호선 상수역에서 도보 4분.<br />
              차보다는 지하철이 편합니다.<br />
              주말 홍대는 차가 많으니까요.
            </p>
            <p className="closing">
              웨딩이 끝나고,<br />
              홍대 골목을 걸어보세요.<br />
              또 다른 하루가 이어집니다.
            </p>
          </div>
        </div>
      </section>

      {validImages.length > 0 && (
        <section className="detail-gallery">
          <div className="container-wide">
            <div className="gallery-grid fade-in">
              {validImages.map(function(image, i) {
                return (
                  <div key={i} className="gallery-item">
                    <img 
                      src={urlFor(image).width(800).url()} 
                      alt={`주차장 ${i + 1}`}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default Parking;
